<a uiSref="portal.video" [uiParams]="{videoId: videoId, startAt: startAtParam, autoplay: true, tab: pulse }">
	<span class="speech-search-result-time">{{ result.start * 1000 | vbTimespan }}</span>
	<span class="speech-search-result-excerpt" [innerHTML]="result.subtitle | safeHtml"></span>
</a>
